// gc-block-slideshow view.js

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.wp-block-gc-blocks-gc-block-slideshow').forEach(slideshow => {
        const instance = new GcBlockSlideshow(slideshow);
        slideshow.gcSlideshowInstance = instance;
        window.gcBlockSlideshows = (window.gcBlockSlideshows || []).concat([instance]);
        window.gcBlockSlideshowsById = window.gcBlockSlideshowsById || {};
        if (slideshow.id) window.gcBlockSlideshowsById[slideshow.id] = instance;
    });
});

class GcBlockSlideshow {
    constructor(container) {
        this.container = container;
        this.options = this.getOptionsFromAttributes();
        this.slides = Array.from(this.container.querySelectorAll('.slideshow-slide'));
        this.lastSlideIndex = null;
        this.currentSlideIndex = 0;
        this.slideIdMap = this.slides.map(slide => slide.getAttribute('data-slide-id'));
        this.setupSlideshow();
        if (this.options.thumbnailsStyle) this.createThumbnails();
        this.updateSlides(null, null, 0);
        this.updateSlideshowSize();
        window.addEventListener('resize', () => this.updateSlideshowSize());
        this.setupGestureControls();
    }

    getOptionsFromAttributes() {
        return {
            autoplay: this.container.getAttribute('data-autoplay') === 'true',
            autoplaySpeed: Math.min(Math.max(parseInt(this.container.getAttribute('data-autoplay-speed'), 10) || 3000, 1000), 10000),
            transitionSpeed: parseInt(this.container.getAttribute('data-transition-speed'), 10) || 500,
            showNavigationArrows: this.container.getAttribute('data-show-navigation-arrows') === 'true',
            showPaginationDots: this.container.getAttribute('data-show-pagination-dots') === 'true',
            loop: this.container.getAttribute('data-loop') === 'true',
            pauseOnHover: this.container.getAttribute('data-pause-on-hover') === 'true',
            keyboardNavigation: this.container.getAttribute('data-keyboard-navigation') === 'true',
            transitionType: this.container.getAttribute('data-transition-type') || 'fade',
            transitionTypeParams: JSON.parse(this.container.getAttribute('data-transition-type-params') || '{}'),
            thumbnailsStyle: this.container.getAttribute('data-thumbnails-style') || '',
        };
    }

    setSlideIndex(newIndex) {
        if (newIndex === this.currentSlideIndex) return;
        this.lastSlideIndex = this.currentSlideIndex;
        this.currentSlideIndex = newIndex;
    }

    setupSlideshow() {
        this.setTransitionCSSVariables();
        this.createHelperElements();
        if (this.options.autoplay) this.startAutoplay();
        this.container.classList.add('is-ready');
        // this.addARIAAttributes();
    }

    setTransitionCSSVariables() {
        this.container.style.setProperty('--transition-duration', `${this.options.transitionSpeed}ms`);
        this.container.style.setProperty('--transition-type', this.options.transitionType);
        for (const [key, value] of Object.entries(this.options.transitionTypeParams)) {
            this.container.style.setProperty(`--${key}`, value);
        }
        this.container.style.setProperty('--transition-direction', '1');
    }

    updateSlideshowSize() {
        this.container.style.setProperty('--slideshow-height-px', `${this.container.clientHeight}px`);
        this.container.style.setProperty('--slideshow-width-px', `${this.container.clientWidth}px`);
        this.container.style.setProperty('--slideshow-width-px-number', `${this.container.clientWidth}`);
        if (this.thumbnailsContainer && this.thumbnailsContainer.childNodes.length > 0) {
            this.container.style.setProperty('--slideshow-thumbnails-width-px-number', `${this.thumbnailsContainer.childNodes[0].clientWidth}`);
        }
    }

    startAutoplay() {
        if (this.autoplayInterval) return;
        this.stopAutoplay();
        this.autoplayInterval = setInterval(() => this.showNextSlide(), this.options.autoplaySpeed);
    }

    stopAutoplay() {
        if (this.autoplayInterval) {
            clearInterval(this.autoplayInterval);
            this.autoplayInterval = null;
        }
    }

    showNextSlide() {
        this.changeSlide((this.currentSlideIndex + 1) % this.slides.length, '1');
    }

    showPreviousSlide() {
        this.changeSlide((this.currentSlideIndex - 1 + this.slides.length) % this.slides.length, '-1');
    }

    showSlideById(id) {
        const targetIndex = this.slideIdMap.indexOf(id);
        if (targetIndex !== -1 && targetIndex !== this.currentSlideIndex) {
            const direction = targetIndex > this.currentSlideIndex ? '1' : '-1';
            this.changeSlide(targetIndex, direction);
        }
    }

    changeSlide(newIndex, direction) {
        this.container.style.setProperty('--transition-direction', direction);
        let prevIndex = this.lastSlideIndex;
        this.setSlideIndex(newIndex);
        requestAnimationFrame(() => {
            this.updateSlides(prevIndex, this.lastSlideIndex, newIndex);
        });
    }

    updateSlides(prevIndex, fromIndex, toIndex) {
        if (fromIndex !== null) {
            this.emitSlideEvent('slideExit', this.slides[fromIndex]);
        }
        if (toIndex !== null) {
            this.emitSlideEvent('slideEnter', this.slides[toIndex]);
        }

        this.updateSlideClasses(prevIndex, 'remove', ['prev-active']);
        this.updateSlideClasses(fromIndex, 'remove', ['is-active']);
        this.updateSlideClasses(fromIndex, 'add', ['is-exiting']);
        this.updateSlideClasses(toIndex, 'add', ['is-active', 'is-entering']);
        this.updateSlideClasses(toIndex, 'remove', ['is-exiting']);
        this.updateSlideClasses(fromIndex, 'add', ['prev-active']);

        const adjacentPrevIndex = (toIndex - 1 + this.slides.length) % this.slides.length;
        const adjacentNextIndex = (toIndex + 1) % this.slides.length;
        this.updateSlideClasses(toIndex, 'add', ['preload']);
        this.updateSlideClasses(adjacentPrevIndex, 'add', ['preload']);
        this.updateSlideClasses(adjacentNextIndex, 'add', ['preload']);

        if (this.slides[fromIndex]) this.addTransitionEndListener(this.slides[fromIndex], ['is-exiting']);
        if (this.slides[toIndex]) this.addTransitionEndListener(this.slides[toIndex], ['is-entering']);
        if (this.options.showPaginationDots) this.updatePaginationDots();
        this.updateThumbnails();
        // this.addARIAAttributes();
    }

    updateSlideClasses(index, action, classes) {
        if (index !== null && this.slides[index]) this.slides[index].classList[action](...classes);
    }

    addTransitionEndListener(slide, classesToRemove) {
        slide.addEventListener('transitionend', function handler() {
            slide.classList.remove(...classesToRemove);
            slide.removeEventListener('transitionend', handler);
        });
    }

    createHelperElements() {
        if (this.options.showNavigationArrows) this.createNavigationArrows();
        if (this.options.showPaginationDots) this.createPaginationDots();
        if (this.options.pauseOnHover && this.options.autoplay) this.setupPauseOnHover();
        if (this.options.keyboardNavigation) this.setupKeyboardNavigation();
    }

    createNavigationArrows() {
        this.createArrowButton('slideshow-prev-button', '◀', this.showPreviousSlide.bind(this));
        this.createArrowButton('slideshow-next-button', '▶', this.showNextSlide.bind(this));
    }

    createArrowButton(className, text, onClickHandler) {
        const button = document.createElement('button');
        button.className = className;
        button.setAttribute('aria-label', text === '◀' ? 'Previous Slide' : 'Next Slide');
        button.setAttribute('aria-controls', this.container.id);
        button.innerText = text;
        button.addEventListener('click', () => {
            if (this.options.autoplay) this.restartAutoplay();
            onClickHandler();
        });
        this.container.appendChild(button);
    }

    createPaginationDots() {
        this.paginationContainer = document.createElement('div');
        this.paginationContainer.className = 'slideshow-pagination-dots';
        this.paginationContainer.setAttribute('role', 'tablist');
        this.slides.forEach((_, index) => this.createPaginationDot(index));
        this.container.appendChild(this.paginationContainer);
        this.updatePaginationDots();
    }

    createPaginationDot(index) {
        const dot = document.createElement('button');
        dot.className = 'slideshow-dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-selected', index === this.currentSlideIndex ? 'true' : 'false');
        dot.setAttribute('aria-controls', this.container.id);
        dot.addEventListener('click', () => {
            if (this.options.autoplay) this.restartAutoplay();
            this.showSlideById(this.slideIdMap[index]);
        });
        this.paginationContainer.appendChild(dot);
    }

    updatePaginationDots() {
        this.paginationContainer.querySelectorAll('.slideshow-dot').forEach((dot, index) => {
            dot.classList.toggle('active', index === this.currentSlideIndex);
            dot.setAttribute('aria-selected', index === this.currentSlideIndex ? 'true' : 'false');
        });
    }

    createThumbnails() {
        this.thumbnailsContainer = document.createElement('div');
        this.thumbnailsContainer.className = 'slideshow-thumbnails-container';
        this.slides.forEach((slide, index) => this.createThumbnail(slide, index));
        this.container.appendChild(this.thumbnailsContainer);
        this.updateThumbnails();
    }

    createThumbnail(slide, index) {
        const thumbnail = document.createElement('div');
        const thumbnailSlide = slide.cloneNode(true);
        thumbnailSlide.classList.remove('slideshow-slide', 'is-active', 'is-entering', 'is-exiting', 'prev-active');
        thumbnailSlide.classList.add('slideshow-thumbnail-slide');
        thumbnail.appendChild(thumbnailSlide);
        thumbnail.classList.add('slideshow-thumbnail');
        thumbnail.addEventListener('click', () => {
            if (this.options.autoplay) this.restartAutoplay();
            this.showSlideById(this.slideIdMap[index]);
        });
        if (this.thumbnailsContainer) this.thumbnailsContainer.appendChild(thumbnail);
    }

    updateThumbnails() {
        if (this.thumbnailsContainer) this.thumbnailsContainer.querySelectorAll('.slideshow-thumbnail').forEach((thumbnail, index) => {
            thumbnail.classList.toggle('is-active', index === this.currentSlideIndex);
        });
    }

    setupPauseOnHover() {
        this.container.addEventListener('mouseenter', this.stopAutoplay.bind(this));
        this.container.addEventListener('mouseleave', this.startAutoplay.bind(this));
    }

    setupKeyboardNavigation() {
        document.addEventListener('keydown', (event) => {
            if (document.activeElement !== document.body) return;
            if (event.key === 'ArrowLeft') {
                if (this.options.autoplay) this.restartAutoplay();
                this.showPreviousSlide();
            } else if (event.key === 'ArrowRight') {
                if (this.options.autoplay) this.restartAutoplay();
                this.showNextSlide();
            }
        });
    }

    setupGestureControls() {

        console.log('Gesture controls setup');
        let startX = 0;
        let endX = 0;

        this.container.addEventListener('touchstart', (event) => {
            console.log('Gesture controls - touchstart');
            startX = event.touches[0].clientX;
        });

        this.container.addEventListener('touchmove', (event) => {
            endX = event.touches[0].clientX;
            event.preventDefault();
        });

        this.container.addEventListener('touchend', () => {
            console.log('Gesture controls - touchend');
            const diffX = startX - endX;
            if (Math.abs(diffX) > 50) {
                if (diffX > 0) {
                    this.showNextSlide();
                } else {
                    this.showPreviousSlide();
                }
            }
        });
    }

    restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
    }

    emitSlideEvent(eventName, slide) {
        console.log('Emitting slide event:', eventName, slide);
        const event = new CustomEvent(eventName, {
            detail: { slideshow: this },
            bubbles: true,
            cancelable: true
        });
        slide.dispatchEvent(event);
    }
}
